interface UserAvatarProps {
  userId: string;
  name: string;
  phone: string;
}

const avatarColors = [
  'bg-info/10 text-info',
  'bg-error/10 text-error',
  'bg-log-fatal/10 text-log-fatal',
  'bg-offline/10 text-offline',
  'bg-success/10 text-success',
  'bg-primary/10 text-primary',
];

function getUserInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return parts.length >= 2
    ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    : name.slice(0, 2).toUpperCase();
}

function getAvatarColor(userId: string) {
  const hash = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return avatarColors[hash % avatarColors.length];
}

export function UserAvatar({ userId, name, phone }: UserAvatarProps) {
  const colorClass = getAvatarColor(userId);
  const initials = getUserInitials(name);

  return (
    <div className="flex items-center gap-3">
      <div
        className={`flex size-10 shrink-0 items-center justify-center rounded-full text-sm font-bold tracking-tight ${colorClass}`}
      >
        {initials}
      </div>
      <div className="min-w-0 flex-1">
        <p className="break-words font-semibold leading-tight text-text-title">{name}</p>
        <p className="break-words text-xs leading-tight text-text-secondary">{phone}</p>
      </div>
    </div>
  );
}
